import { render } from "./SearchProductCard.vue?vue&type=template&id=e0a6a1c0&scoped=true"
import script from "./SearchProductCard.vue?vue&type=script&lang=js"
export * from "./SearchProductCard.vue?vue&type=script&lang=js"

import "./SearchProductCard.vue?vue&type=style&index=0&id=e0a6a1c0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-e0a6a1c0"

export default script